import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    groupPaper: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "100%"
    },
    groupPaperCentered: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "100%",

        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: "center"
    },
    groupPaperZeroDecisionAccuracy: {
        borderColor: theme.palette.error.main,
        backgroundColor: theme.palette.background.paper,
        border: "solid 2px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "100%"
    },
    filterRow: {
        display: 'flex',
        flexWrap: "wrap",
        flexDirection: 'row',
        alignItems: 'center'
    },
    smallPanelHeader: {
        ...theme.typography.h5,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: "center",
        alignItems: "center",
        flexDirection: 'column'
    },
    centeredText: {
        //...theme.typography.h5,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: "center",
        alignItems: "center",
        flexDirection: 'column'
    },
    formControl: {
        minWidth: 180,
        margin: theme.spacing(1),
        color: theme.palette.common.white
    },
    root: {
        marginTop: 15,
        display: 'flex',
        alignItems: "center",
        justifyContent: "center"
    },
    image: {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 20,
        maxWidth: "50%",
        maxHeight: "50%",
        margin: "0 auto"
    },

    // Idea based on https://codepen.io/CrocoDillon/pen/DPbYzd
    medal: {
        position: "relative",
        width: "30%",
        height: 0,
        padding: "15% 0",
        margin: "1em auto",
        borderRadius: "50%",
        boxShadow: "0px 2px 15px rgba(255, 255, 255, 0.2)",

        // https://www.eggradients.com/category/gold-gradient
        backgroundColor: "#ebbe9b",
        backgroundImage: "linear-gradient(315deg, #ebbe9b 0%, #e7a977 74%)",
    },
    medalText: {
        ...theme.typography.h2,
        color: theme.palette.common.black,

        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        textAlign: "center",
    }
}));

export {useStyles};

